import {STRINGS} from "../Constants";

const postMessagePromises = {};

const subscribeAbleEvents = {
    "sendLocaleResponse": sendResponse,
    "sendDarkModeStatus": sendDarkModeStatus
};

window.addEventListener("message", onNewPostMessageFromParent, false);

function onNewPostMessageFromParent(event) {
    if (event.data.method && subscribeAbleEvents.hasOwnProperty(event.data.method)) {
        subscribeAbleEvents[event.data.method](event.data);
    }
}

function generateGuid(){
    /**
     * @return {string}
     */
    function S4() {
        return (((1+Math.random())*0x10000)|0).toString(16).substring(1);
    }
    return (S4() + S4() + "-" + S4() + "-4" + S4().substr(0,3) + "-" + S4() + "-" + S4() + S4() + S4()).toLowerCase();
}

var setCurrentDarkMode = () => {};
export function setDarkModeStateListener(darkModeStateListener) {
  setCurrentDarkMode = darkModeStateListener;
}

export async function getDarkModeStatus() {
    return await postMessagePromised(
      window.parent,
      {
        method: "getDarkModeStatus",
        args: {},
      },
      "*", 200);
}

export async function getLocaleFromParent() {
    return await postMessagePromised(window.parent, {
        method: 'getLocale',
        args: {}
    }, '*',200);
}

function postMessagePromised(targetWindow, message, targetOrigin, timeout) {
    const newGuid = generateGuid();
    message.guid = newGuid;
    postMessagePromises[newGuid] = {};
    postMessagePromises[newGuid]['promise'] = new Promise(function (resolve, reject) {
        postMessagePromises[newGuid]['resolve'] = resolve;
        postMessagePromises[newGuid]['reject'] = reject;
        targetWindow.postMessage(message, targetOrigin);
        if (timeout) {
            setTimeout(() => {
                postMessagePromises[newGuid].resolve(STRINGS.TIMEOUT);
            },timeout);
        }
    });
    return postMessagePromises[newGuid].promise;
}

function sendResponse(data) {
    if (postMessagePromises[data.guid]) {
        postMessagePromises[data.guid].resolve(data.childData);
    }
}

function sendDarkModeStatus(data) {
    setCurrentDarkMode(data.childData.capability);
}



// WEBPACK FOOTER //
// ./src/handler/ParentDataHandler.js